export const EmploymentStatus = [
  "---",
  "短期雇用",
  "体験就職",
  "常用雇用（試用期間後）",
]

export const Prefectures: string[] = [
  "全国",
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
]

export const ShipTypes: string[] = [
  "作業船",
  "タンカー",
  "貨物船",
  "フェリー",
  "特殊船",
  "ガット船",
  "漁船",
  "その他船舶",
]

export const RequiredQualifications: string[] = [
  "1級海技士(航海)",
  "2級海技士(航海)",
  "3級海技士(航海)",
  "4級海技士(航海)",
  "5級海技士(航海)",
  "6級海技士(航海)",
  "1級海技士(機関)",
  "2級海技士(機関)",
  "3級海技士(機関)",
  "4級海技士(機関)",
  "5級海技士(機関)",
  "6級海技士(機関)",
  "1級海技士(通信)",
  "2級海技士(通信)",
  "3級海技士(通信)",
  "1級海技士(電子通信)",
  "2級海技士(電子通信)",
  "3級海技士(電子通信)",
  "4級海技士(電子通信)",
  "1級海技士(小型)",
  "2級海技士(小型)",
  "船舶調理師免許",
  "調理師免許",
  "その他",
]

export const JobTypes = [
  "甲板部",
  "機関部",
  "司厨部",
  "ガット/クレーン士",
  "その他",
]
